var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaitIcon = function SvgWaitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#waitIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9F2FF",
    fillRule: "evenodd",
    d: "M40.5 2.25v10.544a20.1 20.1 0 0 1-5.931 14.314L30.181 31.5l4.387 4.382-.94-.935C29.53 39.366 27 45.261 27 51.75c0 4.054.999 7.87 2.732 11.25h8.518l-31.5.005a2.24 2.24 0 0 1-2.25-2.25V50.206c0-5.409 2.106-10.489 5.931-14.318l4.388-4.388-4.388-4.387A20.12 20.12 0 0 1 4.5 12.793V2.25A2.25 2.25 0 0 1 6.75 0h31.5a2.24 2.24 0 0 1 2.25 2.25",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#waitIcon_svg__b)",
    fillRule: "evenodd",
    d: "M2.25 4.5A2.25 2.25 0 0 1 0 2.25 2.254 2.254 0 0 1 2.25 0h40.5a2.25 2.25 0 0 1 0 4.5zM29.732 63H2.25A2.257 2.257 0 0 1 0 60.75a2.257 2.257 0 0 1 2.25-2.25h25.7a25 25 0 0 0 1.782 4.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#waitIcon_svg__c)",
    fillRule: "evenodd",
    d: "M9 9v3.794C9 17 10.638 20.952 13.613 23.93c0 0 8.887 6.975 8.887 7.569 0-.594 8.888-7.573 8.888-7.573A15.65 15.65 0 0 0 36 12.794V9zm0 49.5v-3.794c0-4.207 1.638-8.158 4.613-11.137 0 .005 8.887-6.975 8.887-7.569 0 .398 3.984 3.658 6.618 5.77A24.5 24.5 0 0 0 27 51.75c0 2.342.333 4.605.95 6.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#waitIcon_svg__d)",
    d: "M51.75 72C62.934 72 72 62.934 72 51.75S62.934 31.5 51.75 31.5 31.5 40.566 31.5 51.75 40.566 72 51.75 72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M58.5 60.75a2.26 2.26 0 0 1-1.593-.657l-6.75-6.75a2.27 2.27 0 0 1-.657-1.593v-9a2.25 2.25 0 0 1 4.5 0v8.069l6.093 6.092a2.25 2.25 0 0 1 0 3.182 2.26 2.26 0 0 1-1.593.657"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "waitIcon_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-18.9844 27.07029 -206.21141 -144.61618 21.797 30.023)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "waitIcon_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-15.00183 39.77675 -74.64322 -28.15174 29.437 23.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "waitIcon_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-17.08581 17.40244 -140.974 -138.40908 51.117 50.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "waitIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h72v72H0z"
  })))));
};
export default SvgWaitIcon;